module.exports = __webpack_public_path__ + "img/browser-chrome-logo.39691d6d.png";